import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHighKodemScore = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.60426 5.82342L2.05113 10.9522C1.97279 11.0125 1.92859 11.1069 1.92859 11.2053L1.92859 12.7582C1.92859 12.8928 2.08328 12.9672 2.18774 12.8848L9.00002 7.55311L15.8123 12.8848C15.836 12.9034 15.8644 12.9149 15.8943 12.918C15.9243 12.9212 15.9545 12.9158 15.9815 12.9026C16.0085 12.8894 16.0313 12.8689 16.0472 12.8434C16.0631 12.8178 16.0715 12.7883 16.0714 12.7582L16.0714 11.2053C16.0714 11.1069 16.0252 11.0125 15.9489 10.9522L9.39779 5.82342C9.16274 5.64061 8.8373 5.64061 8.60426 5.82342Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgHighKodemScore);
export { ForwardRef as ReactComponent };
